import { Amplify } from 'aws-amplify';

import awsconfig from '../aws-exports';

// aws-exports.js tracks the last `amplify env checkout` (often prod after a
// deploy:prod), so it can't be trusted to point local logins at the dev pool.
// When REACT_APP_USER_POOL_ID is set (see .env.development.local) override the
// Cognito pool. Prod builds don't set it, so they keep the aws-exports values.
const poolId = process.env.REACT_APP_USER_POOL_ID;
const config = poolId
  ? {
      ...awsconfig,
      aws_user_pools_id: poolId,
      aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    }
  : awsconfig;

export default function configureAmplify() {
  Amplify.configure(config);
}
